import { render, staticRenderFns } from "./TransactionDeletionsFilterWrapper.vue?vue&type=template&id=56209a95&scoped=true&"
import script from "./TransactionDeletionsFilterWrapper.vue?vue&type=script&lang=ts&"
export * from "./TransactionDeletionsFilterWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionDeletionsFilterWrapper.vue?vue&type=style&index=0&id=56209a95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56209a95",
  null
  
)

export default component.exports